import {rulesContainCart} from './rulesContainCart';

/**
 * Check if rules contain current cart
 * @param searchRules Search rules
 * @returns Contains current cart
 */
export const rulesContainCurrentCart = (
	searchRules: Parameters<typeof rulesContainCart>[0],
) => rulesContainCart(searchRules, 0);

export default rulesContainCurrentCart;
